import { SERVICE_URL } from "../environment";
import { LOGIN_FAIL } from "../errors";
export class LoginService {
    constructor(usersService, sessionService) {
        this.usersService = usersService;
        this.sessionService = sessionService;
    }
    async login(userIdent, password) {
        const response = await fetch(`${SERVICE_URL}/auth`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userIdent, password })
        });
        if (!response.ok) {
            const error = new Error('La autenticación no es correcta.');
            error.name = LOGIN_FAIL;
            throw error;
        }
        const content = await response.json();
        if (content.user) {
            const dataString = JSON.stringify(content.user);
            localStorage.setItem(`${content.user.id}`, dataString);
        }
        return content.accessToken;
    }
}
